import { extendTheme } from '@chakra-ui/react';
import colors from './colors';
import components from './components';

const theme = extendTheme({
  colors,
  components,
  fonts: {
    heading: "'Noto Sans TC', sans-serif",
    body: "'Noto Sans TC', sans-serif",
  },
});

export default theme;
